import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Flex } from "../ui-component/Flex/Flex";
import {
	StyledItem,
	StyledLink,
	StyledList,
	StyledLogoImg,
} from "./NavBar.styled";

export const NavBar = ({ display, toggle }) => {
	const { t } = useTranslation();

	return (
		<>
			<Flex mobileDirection="column" mobileAlign="center">
				<Link to="/" onClick={toggle}>
					<StyledLogoImg
						src="/images/logo/logo.svg"
						alt="presBeton"
						title="presBeton"
					/>
				</Link>
			</Flex>

			<StyledList display={display}>
				<Flex
					mobileDirection="column"
					mobileAlign="center"
					justify="space-between"
					align="center">
					<StyledItem onClick={toggle}>
						<StyledLink to="/">{t("header.homePage")}</StyledLink>
					</StyledItem>
					<StyledItem>
						<StyledLink onClick={toggle} to="description-page">
							{t("header.productPage")}
						</StyledLink>
					</StyledItem>
					<StyledItem>
						<StyledLink onClick={toggle} to="gallery">
							{t("header.galleryPage")}
						</StyledLink>
					</StyledItem>
					<StyledItem>
						<StyledLink onClick={toggle} to="about">
							{t("header.aboutPage")}
						</StyledLink>
					</StyledItem>
					<StyledItem>
						<StyledLink onClick={toggle} to="contact">
							{t("header.contactPage")}
						</StyledLink>
					</StyledItem>
				</Flex>
			</StyledList>
		</>
	);
};
